"use strict";

function classicToRibbon(new_product_type, options) {
  var _this = this;

  if (this.invitations.length > 0) {
    var defaultRibbonColor = options.ribbonColors.filter(function (_ref) {
      var value = _ref.value;
      return !value.match(/none/i);
    })[0].value; // let's see if an instance of invitation has already
    // been assigned a ribbon color, to be smart

    var otherRibbonColor;
    this.invitations.all().forEach(function (component) {
      if (!component.acc_ribbon.match(/none/i) && !otherRibbonColor) {
        otherRibbonColor = component.acc_ribbon;
      }
    });
    this.invitations.all().forEach(function (component, index) {
      if (component.acc_ribbon.match(/none/i)) {
        _this.invitations.at(index).acc_ribbon = otherRibbonColor || defaultRibbonColor;
      }
    });
  }

  if (this.invitationEnvelopes.length > 0) {
    var defaultEnvelopeStyle = 'Double - Blank Inner Envelopes';
    this.invitationEnvelopes.all().forEach(function (component, index) {
      if (component.envelope_style === 'Single Envelopes') {
        _this.invitationEnvelopes.at(index).envelope_style = defaultEnvelopeStyle;
      }
    });
  } // remove belly bands


  this.wrappers.clear(); // I guess this is okay to do.

  this.thickWrappers.clear();
}

function ribbonToClassic() {
  var _this2 = this;

  var suite_ink_colors = this.ink_colors;
  var quantity = 25;

  if (this.invitations.length) {
    quantity = this.invitations.quantity;
    this.invitations.all().forEach(function (component, index) {
      _this2.invitations.at(index).acc_ribbon = 'None';
    });
  } // if there are already wrappers, don't do anything


  if (this.wrappers.length === 0 && this.thickWrappers.length === 0) {
    var wrapper_color = suite_ink_colors[0] || '';
    this.wrappers.add({
      quantity: quantity,
      wrapper_color: wrapper_color
    });
  }
}

function classicRibbonToFloralVellum() {
  var _this3 = this;

  var quantity = 25;

  if (this.invitations.length > 0) {
    quantity = this.invitations.quantity;
    this.invitations.all().forEach(function (component, index) {
      _this3.invitations.at(index).acc_ribbon = 'None';
    });
  }

  if (this.invitationEnvelopes.length > 0) {
    var defaultEnvelopeStyle = 'Double - Blank Inner Envelopes';
    this.invitationEnvelopes.all().forEach(function (component, index) {
      if (component.envelope_style === 'Single Envelopes') {
        _this3.invitationEnvelopes.at(index).envelope_style = defaultEnvelopeStyle;
      }
    });
  }

  if (this.thickWrappers.length === 0) {
    this.thickWrappers.components = this.wrappers.all();
    this.wrappers.clear();
  }

  if (this.waxSeals.length === 0) {
    this.waxSeals.add({
      quantity: quantity
    });
  }

  if (this.vellumJackets.length === 0) {
    this.vellumJackets.add({
      quantity: quantity
    });
  }
}

function floralVellumToClassicRibbon() {
  if (this.thickWrappers.length > 0 && this.wrappers.length === 0) {
    this.wrappers.components = this.thickWrappers.all();
    this.thickWrappers.clear();
  }

  this.waxSeals.clear();
  this.vellumJackets.clear();
}

function classicRibbonToLetterpress() {
  var _this4 = this;

  this.paper_type = this.paper_type.replace(/Matte|Shimmer/, 'Cotton');
  this.letterpressInvitations.components = this.invitations.components;
  this.invitations.clear();
  this.letterpressResponseCards.components = this.responseCards.components;
  this.responseCards.clear();
  this.letterpressSmallEnclosures.components = this.smallEnclosures.components;
  this.smallEnclosures.clear();
  this.letterpressLargeEnclosures.components = this.largeEnclosures.components;
  this.largeEnclosures.clear();

  if (this.invitationEnvelopes.length > 0) {
    var defaultEnvelopeStyle = 'Double - Blank Inner Envelopes';
    this.invitationEnvelopes.all().forEach(function (component, index) {
      if (component.envelope_style === 'Single Envelopes') {
        _this4.invitationEnvelopes.at(index).envelope_style = defaultEnvelopeStyle;
      }
    });
  }
}

function letterpressToClassicRibbon() {
  this.paper_type = this.paper_type.replace('Cotton', 'Matte');
  this.invitations.components = this.letterpressInvitations.components;
  this.letterpressInvitations.clear();
  this.responseCards.components = this.letterpressResponseCards.components;
  this.letterpressResponseCards.clear();
  this.smallEnclosures.components = this.letterpressSmallEnclosures.components;
  this.letterpressSmallEnclosures.clear();
  this.largeEnclosures.components = this.letterpressLargeEnclosures.components;
  this.letterpressLargeEnclosures.clear();
}

function floralVellumToLetterpress() {
  this.paper_type = this.paper_type.replace(/Matte|Shimmer/, 'Cotton');
  this.letterpressInvitations.components = this.invitations.components;
  this.invitations.clear();
  this.letterpressResponseCards.components = this.responseCards.components;
  this.responseCards.clear();
  this.letterpressSmallEnclosures.components = this.smallEnclosures.components;
  this.smallEnclosures.clear();
  this.letterpressLargeEnclosures.components = this.largeEnclosures.components;
  this.largeEnclosures.clear();

  if (this.wrappers.length === 0) {
    this.wrappers.components = this.thickWrappers.components;
    this.thickWrappers.clear();
  }

  this.waxSeals.clear();
  this.vellumJackets.clear();
}

function letterpressToFloralVellum() {
  this.paper_type = this.paper_type.replace('Cotton', 'Matte');
  this.invitations.components = this.letterpressInvitations.components;
  this.letterpressInvitations.clear();
  this.responseCards.components = this.letterpressResponseCards.components;
  this.letterpressResponseCards.clear();
  this.smallEnclosures.components = this.letterpressSmallEnclosures.components;
  this.letterpressSmallEnclosures.clear();
  this.largeEnclosures.components = this.letterpressLargeEnclosures.components;
  this.letterpressLargeEnclosures.clear();

  if (this.thickWrappers.length === 0) {
    this.thickWrappers.components = this.wrappers.components;
    this.wrappers.clear();
  }

  var quantity = 25;

  if (this.invitations.quantity) {
    quantity = this.invitations.quantity;
  }

  if (this.waxSeals.length === 0) {
    this.waxSeals.add({
      quantity: quantity
    });
  }

  if (this.vellumJackets.length === 0) {
    this.vellumJackets.add({
      quantity: quantity
    });
  }
}

module.exports = function (product, product_type) {
  var fn = function fn(x) {
    return x;
  };

  var from = product.product_type;
  var to = product_type;
  var classic = /classic/i;
  var ribbon = /ribbon/i;
  var classic_ribbon = /classic|ribbon/i;
  var floral_vellum = /floral|vellum/i;
  var letterpress = /letterpress/i;

  if (from.match(classic) && to.match(ribbon)) {
    fn = classicToRibbon;
  }

  if (from.match(ribbon) && to.match(classic)) {
    fn = ribbonToClassic;
  }

  if (from.match(classic_ribbon) && to.match(floral_vellum)) {
    fn = classicRibbonToFloralVellum;
  }

  if (from.match(floral_vellum) && to.match(classic_ribbon)) {
    fn = floralVellumToClassicRibbon;
  }

  if (from.match(classic_ribbon) && to.match(letterpress)) {
    fn = classicRibbonToLetterpress;
  }

  if (from.match(letterpress) && to.match(classic_ribbon)) {
    fn = letterpressToClassicRibbon;
  }

  if (from.match(floral_vellum) && to.match(letterpress)) {
    fn = floralVellumToLetterpress;
  }

  if (from.match(letterpress) && to.match(floral_vellum)) {
    fn = letterpressToFloralVellum;
  }

  return fn;
};